import { c as _c } from "react/compiler-runtime";
import type { TypedOnboardingData } from '@onefootprint/request-types/dashboard';
import { InlineAlert } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import { breakingOutputChanges, outputKeyLabel } from '@/playbook-builder/utils/outputs';
type BreakingOutputsAlertProps = {
  /** Outputs published by the versions serving traffic today, one group per version. */
  deployed: TypedOnboardingData[][] | undefined;
  /** Outputs the deployment being created will publish, one group per version. */
  pending: TypedOnboardingData[][] | undefined;
};

/**
 * Warns when the pending deployment drops an output a currently-deployed version publishes, or
 * retypes one. Either breaks integrations reading the onboarding response the moment it lands.
 */
const BreakingOutputsAlert = t0 => {
  const $ = _c(14);
  const {
    deployed,
    pending
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "deployment.form"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  if (!deployed || !pending) {
    return null;
  }
  let T0;
  let t2;
  let t3;
  let t4;
  if ($[1] !== deployed || $[2] !== pending || $[3] !== t) {
    t4 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const changes = breakingOutputChanges(deployed, pending);
      if (changes.length === 0) {
        t4 = null;
        break bb0;
      }
      let t5;
      if ($[8] !== t) {
        t5 = change => {
          const field = outputKeyLabel(change.key);
          return change.kind === "removed" ? t(_temp, {
            field
          }) : t(_temp2, {
            field,
            from: change.from.join(" or "),
            to: change.to.join(" or ")
          });
        };
        $[8] = t;
        $[9] = t5;
      } else {
        t5 = $[9];
      }
      const described = changes.map(t5).join(", ");
      T0 = InlineAlert;
      t2 = "error";
      t3 = t(_temp3, {
        changes: described
      });
    }
    $[1] = deployed;
    $[2] = pending;
    $[3] = t;
    $[4] = T0;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    T0 = $[4];
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
  }
  if (t4 !== Symbol.for("react.early_return_sentinel")) {
    return t4;
  }
  let t5;
  if ($[10] !== T0 || $[11] !== t2 || $[12] !== t3) {
    t5 = <T0 variant={t2}>{t3}</T0>;
    $[10] = T0;
    $[11] = t2;
    $[12] = t3;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};
export default BreakingOutputsAlert;
function _temp($) {
  return $.breakingOutputRemoved;
}
function _temp2($_0) {
  return $_0.breakingOutputRetyped;
}
function _temp3($_1) {
  return $_1.breakingOutputs;
}